// extracted by mini-css-extract-plugin
export var animation = "style-module--animation--bbeba";
export var featureContainer = "style-module--feature-container--98e3f";
export var text = "style-module--text--abf43";